import { getCookie, isString, storage } from '@guardian/libs';
const editionToCountryCodeMap = {
    UK: 'GB',
    US: 'US',
    AU: 'AU',
};
const editionToCountryCode = (editionKey = 'UK') => editionToCountryCodeMap[editionKey];
const countryCookieName = 'GU_geo_country';
const countryOverrideName = 'gu.geo.override';
/*
   This method can be used as a non async way of getting the country code
   after init has been called. Returning locale should cover all/most
   of the cases but if a race condition happen or the cookie is not set,
   we keep fallbacks to cookie or geo from edition.
*/
const getCountryCode = () => {
    const pageEdition = window.guardian.config.page.edition;
    const maybeCountryOverride = storage.local.get(countryOverrideName);
    const countryOverride = isString(maybeCountryOverride)
        ? maybeCountryOverride
        : null;
    return (countryOverride ??
        getCookie({
            name: countryCookieName,
            shouldMemoize: true,
        }) ??
        editionToCountryCode(pageEdition));
};
export { getCountryCode };
